// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingParticipantBreakdown_root__JK0Rd"};